import { loggedIn } from '../../lib';
import { showLightbox } from '../lightbox';

export default () => {
  Array.from(document.querySelectorAll('[data-save-product]')).forEach((button) => {
    button.addEventListener('click', (e) => {
      if (loggedIn()) {
        e.preventDefault();
        $.post('/Product/UpdateFavouriteProducts', {
          productID: button.getAttribute('data-save-product'),
          state: true
        },
        () => {
          window.location = button.href;
        });
      }
      else {
        showLightbox('Login to <a href="/your-tools/save-and-compare">save and compare</a>', 'login');
      }
    });
  });
};
